import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async (options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.kpiAudit.getCurrentTaskCount, {}, options);
    if (error) return { error, status };
    return content || { count: 0 };
};
